import { render, staticRenderFns } from "./DuplicatesFilter.vue?vue&type=template&id=3a565444&"
import script from "./DuplicatesFilter.vue?vue&type=script&lang=ts&"
export * from "./DuplicatesFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports